import { useCallback, useMemo, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

import { getResponseData } from "../../../../../../reactQuery/response";

export function useMobileCardMenuState(card) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openAssignParent, setOpenAssignParent] = useState(false);
  const [openAddWorklog, setOpenAddWorklog] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const cardData = useMemo(() => getResponseData(card, card ?? {}), [card]);

  const handleClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleAssignParent = useCallback(() => {
    setOpenAssignParent(true);
    setAnchorEl(null);
  }, []);

  const handleAddWorklog = useCallback(() => {
    setOpenAddWorklog(true);
    setAnchorEl(null);
  }, []);

  return {
    anchorEl,
    cardData,
    fullScreen,
    handleAddWorklog,
    handleAssignParent,
    handleClick,
    handleClose,
    openAddWorklog,
    openAssignParent,
    setOpenAddWorklog,
    setOpenAssignParent,
  };
}
